(function () {
  'use strict';

  angular
    .module('compartilhamentos')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('root.compartilhamentos', {
        url: '/compartilhamentos?vfiltro=',
        views: {
          'content@': {
            templateUrl: 'compartilhamentos/compartilhamentos.tpl.html',
            controller: 'CompartilhamentosCtrl',
            controllerAs: 'compartilhamentos'
          }
        },
        data: {
          titulo: 'core-permissoes.organizacao.compartilhamentos.sharing',
          tituloDescricao: 'core-permissoes.organizacao.compartilhamentos.entitiesShared',
          role: 'COMPARTILHAMENTOS_VISUALIZAR'
        }
      })
      .state('root.cadastro', {
        url: '/compartilhamentos/cadastro/:id',
        views: {
          'content@': {
            templateUrl: 'compartilhamentos/cadastro.tpl.html',
            controller: 'CadastroCtrl',
            controllerAs: 'cadastro'
          }
        },
        data: {
          titulo: 'core-permissoes.organizacao.compartilhamentos.sharing',
          role: 'COMPARTILHAMENTOS_EDITAR'
        }
      });
  }
}());
